module.exports={
	"Form": "TestSpecificationEditManifest",
	"Scope": "TestSpecification-Edit",
	"Descriptors":
	{
		"TestSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecification-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecification-Edit-Identity",
				"Group": "TestSpecification-Edit-Identity"
			}
		},
		"TestSpecificationDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "TestSpecification-Edit-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecification-Edit-Details",
				"Group": "TestSpecification-Edit-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "TestSpecification-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "TestSpecification-Edit-Details",
				"Group": "TestSpecification-Edit-Details"
			}
		},
		"TestSpecificationDetails.IDTestSpecification":
		{
			"Name": "IDTest Specification",
			"Hash": "TestSpecification-Edit-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.GUIDTestSpecification":
		{
			"Name": "GUIDTest Specification",
			"Hash": "TestSpecification-Edit-GUIDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecification-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecification-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecification-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecification-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-Edit-DataAudit",
				"Group": "TestSpecification-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecification-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecification-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecification-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecification-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecification-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecification-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
